export default {
  title: '{type}を選択',
  uploadImage: '画像をアップロード',
  uploadVideo: '動画をアップロード',
  selectImage: '画像を選択',
  selectVideo: '動画を選択',
  maxCountTip: '最大{count}個の素材を選択できます',
};
